/**
 * Configuração dos filtros para a listagem de pedidos
 */
export const filterConfig = [{
  id: 'NumeroDoPedido',
  type: 'text',
  label: 'Número do Pedido',
  placeholder: 'Digite o número do pedido'
}, {
  id: 'NumeroCarga',
  type: 'text',
  label: 'Número da Carga',
  placeholder: 'Digite o número da carga'
}, {
  id: 'NumeroCTE',
  type: 'text',
  label: 'Número CTE',
  placeholder: 'Digite o número do CTE'
}, {
  id: 'NumeroNF',
  type: 'text',
  label: 'Número NF',
  placeholder: 'Digite o número da NF'
}, {
  id: 'LocalPalletizacao',
  type: 'text',
  label: 'Local de Palletização',
  placeholder: 'Digite o local de palletização'
}, {
  id: 'DataAgendamentoInicio',
  type: 'date',
  label: 'Data de Agendamento (Início)'
}, {
  id: 'DataAgendamentoFim',
  type: 'date',
  label: 'Data de Agendamento (Fim)'
}, {
  id: 'DataIntegracaoInicio',
  type: 'date',
  label: 'Data de Integração (Início)'
}, {
  id: 'DataIntegracaoFim',
  type: 'date',
  label: 'Data de Integração (Fim)'
}];
